<template>
  <div class="ncrm-privacy-registry-filters">
    <template v-for="filter in filters" :key="filter.key">
      <v-text-field
        v-if="filter.key === 'search'"
        v-model="searchInput"
        :label="$t(`${copyKey}.${state.view === 'contact_points' ? 'searchValue' : 'search'}`)"
        prepend-inner-icon="mdi-magnify"
        maxlength="120"
        hide-details
        clearable
      />
      <v-select
        v-else
        :model-value="state[filter.key]"
        :items="filter.items"
        item-title="title"
        item-value="value"
        :label="$t(`${copyKey}.filters.${filter.key}`)"
        hide-details
        clearable
        @update:model-value="$emit('patch', { [filter.key]: $event ?? null })"
      />
    </template>
  </div>
</template>

<script>
import {
  CHANNELS,
  CLASSIFICATIONS,
  CONTACT_POINT_LINKS,
  EVENT_TYPES,
  EVIDENCE_FILTERS,
  EVIDENCE_TYPES,
  MAILJET_SYNC_FILTERS,
  PAIR_STATES,
  PERIOD_DAYS,
  SOURCE_TYPES,
  SPAM_FILTERS,
  SUMMARY_STATES,
  VIEW_FILTERS,
} from "./privacyWorkspaceContracts.mjs";

const SEARCH_DEBOUNCE_MS = 300;
const DP = "ncrm.contacts.dataProtection";
const REGISTRY = `${DP}.workspace.registry`;

// Valorile fiecărui filtru și cheia i18n a etichetei lor. Etichetele refolosesc
// vocabularul tabului de record, ca registrul și recordul să vorbească la fel.
const OPTIONS = Object.freeze({
  summaryState: [SUMMARY_STATES, `${DP}.states`],
  channel: [CHANNELS, `${DP}.record.channels`],
  classification: [CLASSIFICATIONS, `${DP}.record.contactPoints.classifications`],
  link: [CONTACT_POINT_LINKS, `${REGISTRY}.linkOptions`],
  pairState: [PAIR_STATES, `${DP}.record.states`],
  eventType: [EVENT_TYPES, `${DP}.record.events`],
  sourceType: [SOURCE_TYPES, `${DP}.record.sources`],
  evidence: [EVIDENCE_FILTERS, `${REGISTRY}.evidenceOptions`],
  evidenceType: [EVIDENCE_TYPES, `${REGISTRY}.evidenceTypes`],
  attachment: [EVIDENCE_FILTERS, `${REGISTRY}.attachmentOptions`],
  period: [PERIOD_DAYS, `${REGISTRY}.periods`],
  mailjetSync: [MAILJET_SYNC_FILTERS, `${REGISTRY}.mailjetSyncOptions`],
  spam: [SPAM_FILTERS, `${REGISTRY}.spamOptions`],
});

export default {
  name: "NcrmPrivacyRegistryFilters",
  props: {
    state: { type: Object, required: true },
    // Scopurile tenantului, pentru filtrul `purposeId`: `[{ id, name }]`.
    purposes: { type: Array, default: () => [] },
  },
  emits: ["patch"],
  data: () => ({ searchInput: "", searchTimer: null }),
  computed: {
    copyKey() { return REGISTRY; },
    filters() {
      return VIEW_FILTERS[this.state.view].map((key) => ({ key, items: this.itemsOf(key) }));
    },
  },
  watch: {
    "state.search": { immediate: true, handler(value) { this.searchInput = value || ""; } },
    searchInput(value) {
      clearTimeout(this.searchTimer);
      if ((value || "").trim() === this.state.search) return;
      this.searchTimer = setTimeout(() => this.$emit("patch", { search: (value || "").trim() }), SEARCH_DEBOUNCE_MS);
    },
  },
  beforeUnmount() { clearTimeout(this.searchTimer); },
  methods: {
    itemsOf(key) {
      if (key === "search") return [];
      if (key === "purposeId") return this.purposes.map(({ id, name }) => ({ value: id, title: name || `#${id}` }));
      const [values, labels] = OPTIONS[key];
      return values.map((value) => ({ value, title: this.$t(`${labels}.${value}`) }));
    },
  },
};
</script>

<style scoped>
.ncrm-privacy-registry-filters {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: 12px; align-items: center;
}
</style>
